import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { BehaviorSubject, fromEvent, of, Subject, takeUntil } from 'rxjs';
import { Swiper } from 'swiper';

export type PcpSwipeEvent = {
    swipeIndex: number
};

@Directive({ selector: '[pcpSwiper]' })
export class SwiperDirective implements AfterViewInit, OnDestroy {

    @Output('swipe') slideChange = new EventEmitter<PcpSwipeEvent>();

    @Input() set swiperIndex(index: number) {
        this.swiperIndexSubject.next(index);
    }

    /** Should be called each time this.element was hidden or shown.
     * Required to be defined in the hosted element.
     * https://swiperjs.com/swiper-api#method-swiper-update
    */
    @Input() update$ = of(void(0));

    private swiper!: Swiper;
    private readonly swiperIndexSubject = new BehaviorSubject<number>(0);
    private readonly destroy$ = new Subject<void>();

    constructor(
        private element: ElementRef<HTMLElement>,
    ) {
    }

    ngAfterViewInit(): void {
        //init:
        this.swiper = new Swiper(this.element.nativeElement, {
            direction: 'horizontal',
            spaceBetween: 0,
            mousewheel: true,
        });
        //events:
        fromEvent(this.swiper, 'slideChange')
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.slideChange.emit({ swipeIndex: this.swiper.activeIndex });
            });
        this.swiperIndexSubject.asObservable()
            .pipe(takeUntil(this.destroy$))
            .subscribe(index => {
                this.swiper.slideTo(index);
            });
        this.update$
            .pipe(takeUntil(this.destroy$))
            .subscribe(_ => {
                this.swiper.update()
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

}
